// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-xYPOUD{background:#fff;flex-direction:column;height:100%;min-height:0;display:flex}.status-Ph1XsT{color:#64748b;text-align:center;flex:1;justify-content:center;align-items:center;padding:24px;font-size:14px;display:flex}.iframe-wrapper-wtuBCq{flex:1;min-height:0;position:relative}.iframe-TjtzGi{border:none;width:100%;height:100%;display:block}.loading-mask-i9JZkU{background:rgba(255,255,255,.9);justify-content:center;align-items:center;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root-xYPOUD`,
	"status": `status-Ph1XsT`,
	"iframe-wrapper": `iframe-wrapper-wtuBCq`,
	"iframeWrapper": `iframe-wrapper-wtuBCq`,
	"iframe": `iframe-TjtzGi`,
	"loading-mask": `loading-mask-i9JZkU`,
	"loadingMask": `loading-mask-i9JZkU`
};
export default ___CSS_LOADER_EXPORT___;
